import { Dc_Text_Blockquote } from "@op/sf-op";
import type { BlockquoteNodeProps } from "../../../../../renderer/RichTextRenderer/nodes/BlockquoteNode";

const BlockquoteNode = ({ children, id }: BlockquoteNodeProps) => {
  return <Dc_Text_Blockquote text={children as string} id={id} />;
};

export default BlockquoteNode;
